import React, { useState, useEffect } from "react";
import {
    Button, Modal, ModalHeader, ModalBody,
    ModalFooter,
    FormGroup,
    Row,
    Col,
    Input,
    Label, Table
} from "reactstrap";
import { rightsidebar, getDocumentsById, getFileDoc, getFileDetail } from "../../../../context/actions/document";
import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension, pagination } from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { resetAutoSaveData } from "../../../../context/actions/tempAction";
import { getFileSetting } from "../../../../context/actions/fileSetting";

const ReviewModal = ({ modalOpen, toggleModal, reviewRequestedToday2 }) => {



    const [fileClicked, setFileClicked] = useState(false);
    const history = useHistory()
    const dispatch = useDispatch()
    const [paginations] = useState(pagination.limit);
    const [disable, setDisable] = useState(false);
    const [loader, setLoader] = useState();


    const handleDate = (value) => {
        const date = new Date(value)
        const formattedDate = date.toLocaleDateString("en-US", {
            month: "long", // Use two-digit representation for the month (e.g., 07)
            day: "2-digit",   // Use two-digit representation for the day (e.g., 24)
            year: "numeric"   // Use numeric representation for the year (e.g., 2023)
        });
        return formattedDate;
    }


    const viewFile = (item) => {

        setLoader(true);
        setFileClicked(item._id)
        // let tab = "C"
        // if (item.mode == "autosave_V")
        //     tab = "V"

        // let data = reviewRequestedToday2.filter((data) => {
        //     return data._id != item._id
        // })

        // dispatch(getDocumentsById({ folder: item.folder, limit: paginations, page: 1, fields: '_id' }, ((result) => {
        // })));
        // dispatch(getFileSetting(((result) => {
        // })));
        dispatch(
            getFileDoc({ docId: item._id.toString() }, (result) => {
                setLoader(false);
                if (result) {
                    if (Object.keys(result).length) {
                        // localStorage.setItem('version', item.version)
                        dispatch({ type: "REDIRECT", data: [item] });
                        window.location.href = '/documentDetail';
                        // window.open(`/documentDetail`, "_blank")
                        localStorage.setItem('dashboard_redirected', true)
                        // dispatch({ type: "SET_AUTOSAVE_DATA", data: data })
                        // setDisable(false)
                        setFileClicked(false)
                    }
                    else { //else condition is used to check if response is present or not. This condititon comes to play is the file is archived. 
                        window.open(`/documents`, "_blank");

                        toast.success("The file is already archived", toasterConfig);
                        setFileClicked(false)
                    }
                }
            })
        )
    }





    return (
        <div>
            {/* Button to open the modal */}

            {/* Modal component */}
            <Modal isOpen={modalOpen} toggle={toggleModal} style={{ maxHeight: '500px', overflowY: 'auto', top: '50%', transform: 'translateY(-50%)' }}>

                <ModalHeader>Docs needing review from today</ModalHeader>
                <ModalBody>
                    <Table style={{ maxHeight: "30px" }}>
                        <thead>
                            <tr>
                                <th style={{ color: 'rgba(47, 65, 82, 1)' }}>Files</th>
                                <th style={{ color: 'rgba(47, 65, 82, 1)' }}>Loan Number</th>
                                <th style={{ color: 'rgba(47, 65, 82, 1)' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reviewRequestedToday2 && reviewRequestedToday2.map((item) => {
                                return (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>{item.loan_number}</td>
                                        <td>
                                            <Button color="link" onClick={() => viewFile(item)} ><FontAwesomeIcon icon={faPenToSquare} size="lg" /> </Button> {/* disabled={fileClicked === item._id}  */}
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </Table>
                </ModalBody>
                <ModalFooter>
                    <Button
                        disabled={disable}
                        color="secondary"
                        onClick={toggleModal}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            {loader && <LoaderUI className="modal-overlay-level-1" overlay />}
        </div>
    );
};

export default ReviewModal;